<template>
	<div class="main-container">
		<slot />
	</div>
</template>

<style scoped lang="scss">
@layer components
{
	.main-container
	{
		display:grid;
		grid-template-columns:minmax(0, 1fr);
		min-height:100vh;
		position:relative;
	}
}
</style>
